import axiosInstance from "../../config/axiosInstance";
import { AccessResponse } from "../../types/users/userAccess";

const getUserAccess = async () => {
  const { data } = await axiosInstance.get<AccessResponse>(
    "/api/getUserDetails"
  );
  return data.data;
};

const userAccessService = {
  getUserAccess,
};

export default userAccessService;
